const HEADER_PANEL_EVENT = "catalog:header-surface-open";

export function dispatchHeaderPanelEvent(detail) {
  if (typeof window === "undefined" || typeof window.dispatchEvent !== "function") {
    return;
  }
  let event;
  if (typeof window.CustomEvent === "function") {
    event = new CustomEvent(HEADER_PANEL_EVENT, { detail });
  } else if (typeof document !== "undefined" && typeof document.createEvent === "function") {
    event = document.createEvent("CustomEvent");
    event.initCustomEvent(HEADER_PANEL_EVENT, true, true, detail);
  } else if (typeof Event === "function") {
    event = new Event(HEADER_PANEL_EVENT);
    event.detail = detail;
  } else {
    return;
  }
  window.dispatchEvent(event);
}

export { HEADER_PANEL_EVENT };
